import React from 'react';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';

import aboutAwards from 'assets/about-awards.png';
import aboutAwardsFr from 'assets/about-awards_fr.png';
import PageTitle from 'shared/PageTitle';
import Auth from 'shared/Auth';
import Text from 'ui/Text';

const AboutAwards = () => {
  const defaultLang = get(Auth.getLanguage(), 'local_locale');

  const indicators = {
    fr: aboutAwardsFr,
    en: aboutAwards,
  };

  return (
    <div id="about">
      <PageTitle title="About the Awards" />
      <div>
        <div className="inner-content about-explainer bg-light-grey">
          <Text type="heading-semi-bold" modifiers="text-center title heavy">
            <FormattedMessage id="About.AboutTheAward" defaultMessage="About the Awards" />
            <span className="fake-border fake-border__underline center-block" />
          </Text>
          <div className="row no-margin">
            <div className="col-sm-12 col-md-9 col-lg-9 center-block">
              <Text type="explainer" modifiers="explanations-area plain-message text-center">
                <FormattedMessage
                  id="AboutAwards.Explanation.First"
                  defaultMessage="
                    The African CSO Excellence Awards is a joint initiative between
                    EPIC-Africa and the Rockefeller Foundation. The Awards highlight the
                    importance of organizational capacity to achieve program impact.
                    The African CSO Excellence Awards reward organizations that demonstrate
                    excellence across eight key elements of organizational capacity:
                  "
                />
                <span className="semi-bold emphasis">
                  <FormattedMessage
                    id="AboutAwards.Explanation.Second"
                    defaultMessage="
                      Strategic Ability and Adaptability, Leadership and Governance, Financial Health and
                      Management, Human Resources and Staff Development, Operations, Communications,
                      Partnerships and Alliances, Monitoring and Evaluation.
                  "
                  />
                </span>
              </Text>
            </div>
          </div>
          <div className="text-center">
            <img className="explainer-pic" src={get(indicators, defaultLang)} alt="About Awards" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAwards;



// WEBPACK FOOTER //
// ./src/components/HomePage/AboutAwards.js